import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import PeriodClosingVoucherDetailsList from "./PeriodClosingVoucherDetailsList";

function PeriodClosingVoucherDetails() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>Period Closing Voucher Details</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <PeriodClosingVoucherDetailsList />
      </div>
    </div>
  );
}

export default PeriodClosingVoucherDetails;
